export enum ContentType {
  PERIODIC = 1,
  ARTICLE = 2,
  BOOK = 3,
  CODE = 4,
  VIDEO = 6,
  CHAPTER = 11,
  CODE_ITEM = 13,
  LEGISLATION = 14,
  INFORMATIVE = 15
}
